import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllExpenses = async () => {

        const { fetchAllExpenses } = FetchData
        const { executeFetch } = fetchAllExpenses

        executeFetch()

    }

    const handleClickFetchSpecificExpense = async (idexpense) => {
        
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificExpense } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificExpense

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idexpense: idexpense})
        executeFetch()

        handleClickShowForm(true)

    }

    const handleClickEnableDisableExpense = async (idexpense, estado) => {
        console.log('handleClickEnableDisableExpense', {idexpense, estado})
        Swal.fire({
            title: '¿Está seguro de cambiar el estado de este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de casas que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/legal/enable-disable-expense`, {idexpense, estado})
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        handleClickFetchAllExpenses()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickDeleteExpense = async (idexpense) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal/delete-expense/${idexpense}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllExpenses()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const _dataBody = {
            idexpense: formState.idexpense,
            type_expense: formState.type_expense,
            descripcion: formState.descripcion,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idexpense > 0){

            await marvarApi.put( `/legal/update-expense/${_dataBody.idexpense}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllExpenses()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal/create-expense`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllExpenses()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllExpenses,
        handleClickFetchSpecificExpense,
        handleClickEnableDisableExpense,
        handleClickDeleteExpense,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}